import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { Alert, IconButton, Snackbar } from "@mui/material";

const AlertMassage = (props) => {
    const { severityType } = props;
    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={props.open}
                autoHideDuration={severityType === "success" ? 2000 : 6000}
                onClose={props.handleClose}
                action={[
                    <IconButton key="close" onClick={props.handleClose}>
                        <CloseIcon />
                    </IconButton>
                ]}
            >
                <Alert
                    onClose={props.handleClose}
                    severity={severityType}>
                    {props.message}
                </Alert>

            </Snackbar>
        </div>
    );
}

export default AlertMassage;